export const BASE_DOMAIN = 'microcms.io';
export const API_VERSION = 'v1';
export const MAX_RETRY_COUNT = 2;
export const MIN_TIMEOUT_MS = 5000;
